export const TABLE_COLUMNS = [{ label: "Group" }, { label: "Role" }];
